import { render, staticRenderFns } from "./SearchResultsList.vue?vue&type=template&id=4ebc5cf6&scoped=true"
import script from "./SearchResultsList.vue?vue&type=script&lang=js"
export * from "./SearchResultsList.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsList.vue?vue&type=style&index=0&id=4ebc5cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc5cf6",
  null
  
)

export default component.exports